import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e15fb5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed_dialog_header_icon" }
const _hoisted_2 = { class: "fixed_dialog_header_title" }
const _hoisted_3 = {
  key: 0,
  class: "fixed_dialog_header_close"
}
const _hoisted_4 = {
  key: 0,
  class: "fixed_dialog_body"
}
const _hoisted_5 = {
  key: 0,
  class: "write_idea"
}
const _hoisted_6 = { class: "write_idea_title" }
const _hoisted_7 = { class: "write_idea_body" }
const _hoisted_8 = {
  key: 1,
  class: "send_guide_body"
}
const _hoisted_9 = {
  key: 0,
  class: "send_guide_body_title"
}
const _hoisted_10 = {
  key: 1,
  class: "send_guide_body_content"
}
const _hoisted_11 = {
  key: 2,
  class: "send_guide_body_title"
}
const _hoisted_12 = {
  key: 1,
  class: "fixed_dialog_footer"
}
const _hoisted_13 = { class: "fixed_dialog_footer_button" }

import IconButton from '@/components/molecules/IconButton.vue'
import SimpleButton from '@/components/atoms/SimpleButton.vue'
import SimpleTextarea from '@/components/atoms/SimpleTextarea.vue'
import http from '@/js/utils/http.js'
import API from '@/js/const/api'
import { computed, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackDialog',
  setup(__props) {

const openState = ref(false)
const loading = ref(false)
const writeState = ref(true)
const sendState = ref(false)
const message = ref('')

const sendDisabled = computed<boolean>(() => message.value === '')

const toggleDialog = () => {
  openState.value = !openState.value
}

const close = () => {
  openState.value = false
  writeState.value = true
}

const sendFeedback = async () => {
  loading.value = true
  try {
    await http.post(API.SEND_FEEDBACK, { message: message.value })
    sendState.value = true
    message.value = ''
  } catch (error) {
    sendState.value = false
  } finally {
    loading.value = false
    writeState.value = false
  }
}

const keyUpEsc = (e: KeyboardEvent) => {
  // escが押されたらダイアログを閉じる
  if (e.key === 'Escape') {
    close()
  }
}

watch(openState, (value) => {
  if (value === true) {
    document.body.addEventListener('keyup', keyUpEsc)
  } else {
    document.body.removeEventListener('keyup', keyUpEsc)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["fixed_dialog", { open_dialog: openState.value }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["fixed_dialog_header", { close_header: !openState.value }]),
      onClick: toggleDialog,
      "data-test": "feedback-dialog"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(IconButton, {
          useBorder: false,
          useCircle: true,
          size: "S",
          icon: "chat_bubble_outline",
          iconColor: "color-primary",
          bgColor: "white"
        })
      ]),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('feedback_dialog.to_ciao_camera')), 1),
      (openState.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(IconButton, {
              useBorder: false,
              icon: "close",
              iconColor: "color-dark4",
              disabled: loading.value,
              onClick: close
            }, null, 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (openState.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (writeState.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('feedback_dialog.please_send')), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(SimpleTextarea, {
                    class: "textaria",
                    disabled: loading.value,
                    placeholder: "",
                    modelValue: message.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message).value = $event))
                  }, null, 8, ["disabled", "modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (!writeState.value && !loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (sendState.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('feedback_dialog.thank_feedback')), 1))
                  : _createCommentVNode("", true),
                (sendState.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('feedback_dialog.feedback_comments')), 1))
                  : _createCommentVNode("", true),
                (!sendState.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('feedback_dialog.failed_send')), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (openState.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (writeState.value)
              ? (_openBlock(), _createBlock(SimpleButton, {
                  key: 0,
                  onClick: sendFeedback,
                  useBorder: false,
                  color: "bg-color-primary-grd",
                  size: "size-m",
                  disabled: _unref(sendDisabled),
                  loading: loading.value,
                  iconColor: "color-white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('feedback_dialog.send')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"]))
              : (_openBlock(), _createBlock(SimpleButton, {
                  key: 1,
                  onClick: close,
                  useBorder: false,
                  color: "bg-color-primary-grd",
                  size: "size-m",
                  loading: loading.value,
                  iconColor: "color-white"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('feedback_dialog.close')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})